import {SetGetCountOnline} from './thunk/setGetCountOnline';
import {SetGetDetalization} from './thunk/setGetDetalization';
import {SetGetInformationUsers} from './thunk/setGetInformationUsers';

export const Thunks = {
    SetGetCountOnline,
    SetGetDetalization,
    SetGetInformationUsers
}